export let UBManageElementType = /*#__PURE__*/function (UBManageElementType) {
  UBManageElementType["Button"] = "BUTTON";
  UBManageElementType["Dropdown"] = "DROPDOWN";
  return UBManageElementType;
}({});
//# sourceMappingURL=ub-manage-element-mode.js.map